import moneyString from '../moneyString.js'

function calculateChangeInNumberOfNightsBefore (oldState, newState) {
  const oldStays = oldState.cart.extraStaysBefore
  const newStays = newState.cart.extraStaysBefore

  const oldNights = oldStays.nights?oldStays.nights:0
  const newNights = newStays.nights?newStays.nights:0
  return (newNights-oldNights)
}

function calculateChangeInNumberOfNightsAfter (oldState, newState) {
  const oldStays = oldState.cart.extraStaysAfter
  const newStays = newState.cart.extraStaysAfter

  const oldNights = oldStays.nights?oldStays.nights:0
  const newNights = newStays.nights?newStays.nights:0
  return (newNights-oldNights)
}

function createCartLineForExtraNightsBefore (extraStay, delta) {
  return {
    "value": `${moneyString(extraStay.total)}`,
    "product": {
      "id": `${extraStay.selectedHotel.id}`,
      "name": `${extraStay.selectedHotel.name} ${extraStay.selectedHotel.code}`,
      "category": "Extras/Extension/pre",
      "quantity": `${delta}`,
      "value": `${moneyString(extraStay.total)}`,
    },
  }
}

function createCartLineForExtraNightsAfter (extraStay, delta) {
  return {
    "value": `${moneyString(extraStay.total)}`,
    "product": {
      "id": `${extraStay.selectedHotel.id}`,
      "name": `${extraStay.selectedHotel.name} ${extraStay.selectedHotel.code}`,
      "category": "Extras/Extension/post",
      "quantity": `${delta}`,
      "value": `${moneyString(extraStay.total)}`,
    },
  }
}

export default {
  eventsFor: (oldState, newState) => {

    const events = []

    if (oldState && oldState.priceBreakdown && newState && newState.priceBreakdown) {
      const addCartLines = []
      const removeCartLines = []

      const changeInNumberOfNightsBefore = calculateChangeInNumberOfNightsBefore(oldState, newState)
      if (changeInNumberOfNightsBefore >0) {
        addCartLines.push(createCartLineForExtraNightsBefore(newState.cart.extraStaysBefore, changeInNumberOfNightsBefore, newState.cart.cartId))
      } else if (changeInNumberOfNightsBefore <0) {
        removeCartLines.push(createCartLineForExtraNightsBefore(oldState.cart.extraStaysBefore, -changeInNumberOfNightsBefore, oldState.cart.cartId))
      }

      const changeInNumberOfNightsAfter = calculateChangeInNumberOfNightsAfter(oldState, newState)
      if (changeInNumberOfNightsAfter >0) {
        addCartLines.push(createCartLineForExtraNightsAfter(newState.cart.extraStaysAfter, changeInNumberOfNightsAfter, newState.cart.cartId))
      } else if (changeInNumberOfNightsAfter <0) {
        removeCartLines.push(createCartLineForExtraNightsAfter(oldState.cart.extraStaysAfter, -changeInNumberOfNightsAfter, oldState.cart.cartId))
      }

      if (addCartLines.length) {
        events.push({
          'event': 'addToCart',
          'cart_lines': addCartLines,
        })
      }

      if (removeCartLines.length) {
        events.push({
          'event': 'removeFromCart',
          'cart_lines': removeCartLines,
        })
      }
    }

    return events
  },
  cartLinesFor (currentState) {
    const cartLines = []
    if (currentState.cart.extraStaysBefore.nights) {
      cartLines.push(createCartLineForExtraNightsBefore(currentState.cart.extraStaysBefore, currentState.cart.extraStaysBefore.nights))
    }
    if (currentState.cart.extraStaysAfter.nights) {
      cartLines.push(createCartLineForExtraNightsAfter(currentState.cart.extraStaysAfter, currentState.cart.extraStaysAfter.nights))
    }
    return cartLines
  },
}